module.exports = __webpack_public_path__ + "static/media/thumbnail-csarnokepulet-alapozas-tahi.49bc4528.jpg";